var _path, _path2, _path3, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 192,
    height: 192,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,16v3l-1.981,1H5.984L4,19v-3l1.35-1c0.55-1.18,1.76-2,3.15-2h7c1.39,0,2.6,0.82,3.15,2L20,16z",
    opacity: 0.35,
    fill: "#66B2B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,20h-5C2.12,20,1,18.88,1,17.5S2.12,15,3.5,15h1.85C5.12,15.45,5,15.96,5,16.5C5,18.43,6.57,20,8.5,20z",
    fill: "#66B2B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17.5c0,1.38-1.12,2.5-2.5,2.5h-5c1.93,0,3.5-1.57,3.5-3.5c0-0.54-0.12-1.05-0.35-1.5h1.85C21.88,15,23,16.12,23,17.5z",
    fill: "#66B2B2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4,
    opacity: 0.35,
    fill: "#66B2B2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 9,
    r: 3,
    opacity: 0.35,
    fill: "#66B2B2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 9,
    r: 3,
    opacity: 0.35,
    fill: "#66B2B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUser);
export default __webpack_public_path__ + "static/media/total-user.be3b922db928f71c91fa84e76903d266.svg";
export { ForwardRef as ReactComponent };